var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTriangleSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1024px",
    height: "768px",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 1024000 768000",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 192000,
    y: 64000,
    width: 640000,
    height: 640000
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id1",
    gradientUnits: "userSpaceOnUse",
    x1: 394500,
    y1: 356500,
    x2: 752500,
    y2: 356500
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id2",
    gradientUnits: "userSpaceOnUse",
    x1: 272500,
    y1: 382000,
    x2: 668500,
    y2: 382000
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "black"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "id3",
    gradientUnits: "userSpaceOnUse",
    x1: 306500,
    y1: 433000,
    x2: 752500,
    y2: 433000
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 1,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 1,
    stopColor: "white"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    visibility: "hidden"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id0)"
  }, /*#__PURE__*/React.createElement("image", {
    x: 192000,
    y: 64000,
    width: 640000,
    height: 640000,
    xlinkHref: "29540-triangleSvg-767315fe-d41e-4349-8bf4-d11af6404e8e_Images\\\\\\\\29540-triangleSvg-767315fe-d41e-4349-8bf4-d11af6404e8e_ImgID1.png"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "middle"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_1Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2119497957024"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#id1)",
    stroke: "black",
    strokeWidth: 666.709,
    points: "551500,176500 486500,177500 668500,490500 422862,490166 394500,536500 752500,535500 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#id2)",
    stroke: "black",
    strokeWidth: 666.709,
    points: "486500,177500 272500,535500 306500,586500 490500,276500 609858,490500 668500,490500 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#id3)",
    stroke: "black",
    strokeWidth: 666.709,
    points: "490500,276500 520607,330479 394500,536500 752500,535500 720500,589500 306500,586500 "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M362757 137675l3797 -342c178,1536 597,2795 1258,3784 662,981 1686,1778 3072,2389 1387,604 2952,910 4687,910 1543,0 2901,-227 4082,-690 1180,-462 2055,-1095 2631,-1898 576,-804 867,-1679 867,-2617 0,-953 -277,-1785 -832,-2503 -554,-711 -1472,-1309 -2752,-1799 -818,-313 -2631,-811 -5440,-1487 -2809,-675 -4771,-1308 -5895,-1905 -1458,-768 -2539,-1721 -3250,-2852 -718,-1130 -1073,-2403 -1073,-3804 0,-1550 440,-2994 1315,-4331 875,-1344 2148,-2361 3833,-3058 1678,-697 3548,-1045 5604,-1045 2261,0 4259,362 5987,1095 1728,725 3058,1799 3989,3221 932,1416 1430,3023 1501,4814l-3883 299c-206,-1927 -910,-3385 -2112,-4366 -1202,-988 -2979,-1479 -5326,-1479 -2446,0 -4231,448 -5348,1344 -1116,896 -1678,1977 -1678,3242 0,1096 398,1999 1188,2710 782,704 2809,1436 6094,2176 3285,746 5540,1394 6763,1948 1770,818 3086,1849 3932,3108 846,1252 1266,2695 1266,4330 0,1629 -462,3151 -1394,4587 -932,1437 -2261,2553 -4004,3350 -1742,796 -3697,1194 -5880,1194 -2760,0 -5071,-405 -6934,-1209 -1870,-803 -3328,-2012 -4387,-3633 -1067,-1615 -1622,-3442 -1678,-5483z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "black",
    fillRule: "nonzero",
    d: "M400218 144139l512 3314c-1052,220 -1998,334 -2823,334 -1358,0 -2411,-213 -3165,-647 -746,-434 -1273,-996 -1578,-1700 -306,-704 -455,-2183 -455,-4437l0 -12758 -2774 0 0 -2901 2774 0 0 -5475 3754 -2255 0 7730 3755 0 0 2901 -3755 0 0 12971c0,1074 64,1764 199,2069 128,306 342,548 640,733 299,178 726,270 1280,270 413,0 960,-49 1636,-149z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    fill: "black",
    fillRule: "nonzero",
    d: "M418387 147488l0 -3292c-1721,2510 -4053,3762 -7005,3762 -1301,0 -2517,-249 -3648,-747 -1130,-505 -1969,-1131 -2517,-1885 -548,-761 -932,-1685 -1152,-2780 -149,-740 -228,-1906 -228,-3499l0 -13703 3755 0 0 12253c0,1955 78,3278 228,3954 234,988 732,1756 1500,2318 761,562 1700,846 2823,846 1124,0 2176,-284 3157,-860 982,-576 1679,-1366 2091,-2354 405,-989 612,-2432 612,-4317l0 -11840 3754 0 0 22144 -3370 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "black",
    fillRule: "nonzero",
    d: "M441946 147488l0 -2809c-1401,2183 -3463,3279 -6187,3279 -1763,0 -3385,-484 -4857,-1458 -1479,-967 -2624,-2326 -3441,-4061 -811,-1742 -1217,-3740 -1217,-6001 0,-2205 370,-4203 1103,-6002 739,-1792 1842,-3172 3313,-4125 1465,-960 3115,-1436 4928,-1436 1337,0 2525,284 3563,846 1038,562 1885,1301 2539,2204l0 -10986 3754 0 0 30549 -3498 0zm-11862 -11043c0,2830 598,4942 1799,6343 1195,1401 2611,2098 4239,2098 1642,0 3036,-669 4188,-2006 1145,-1337 1721,-3378 1721,-6123 0,-3015 -583,-5233 -1756,-6648 -1167,-1416 -2610,-2119 -4324,-2119 -1671,0 -3065,675 -4188,2033 -1117,1358 -1679,3499 -1679,6422z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "black",
    fillRule: "nonzero",
    d: "M466486 140320l3883 512c-604,2255 -1735,4011 -3385,5255 -1650,1245 -3755,1871 -6322,1871 -3228,0 -5788,-996 -7680,-2987 -1891,-1984 -2837,-4779 -2837,-8370 0,-3712 953,-6599 2866,-8647 1912,-2055 4394,-3079 7445,-3079 2951,0 5362,1003 7232,3015 1870,2012 2809,4843 2809,8491 0,220 -7,554 -21,995l-16491 0c142,2425 825,4288 2062,5575 1230,1288 2774,1935 4615,1935 1373,0 2546,-363 3513,-1089 974,-725 1742,-1884 2311,-3477zm-12288 -6016l12331 0c-163,-1863 -640,-3257 -1415,-4188 -1188,-1444 -2738,-2169 -4637,-2169 -1720,0 -3164,576 -4337,1728 -1167,1152 -1814,2695 -1942,4629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    fill: "black",
    fillRule: "nonzero",
    d: "M475112 147488l0 -22144 3371 0 0 3143c1621,-2410 3968,-3612 7033,-3612 1337,0 2560,242 3676,718 1117,477 1956,1109 2510,1884 555,776 946,1700 1166,2767 136,697 207,1913 207,3648l0 13596 -3755 0 0 -13454c0,-1529 -142,-2674 -434,-3427 -291,-754 -810,-1359 -1550,-1814 -739,-448 -1614,-676 -2610,-676 -1593,0 -2965,505 -4124,1522 -1159,1010 -1735,2937 -1735,5768l0 12081 -3755 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    fill: "black",
    fillRule: "nonzero",
    d: "M506991 144139l512 3314c-1052,220 -1998,334 -2823,334 -1358,0 -2411,-213 -3164,-647 -747,-434 -1273,-996 -1579,-1700 -306,-704 -455,-2183 -455,-4437l0 -12758 -2774 0 0 -2901 2774 0 0 -5475 3754 -2255 0 7730 3755 0 0 2901 -3755 0 0 12971c0,1074 65,1764 200,2069 128,306 341,548 639,733 299,178 726,270 1281,270 412,0 960,-49 1635,-149z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 7,
    fill: "black",
    fillRule: "nonzero",
    points: "519734,148000 528609,116427 531631,116427 522756,148000 "
  }), /*#__PURE__*/React.createElement("path", {
    id: 8,
    fill: "black",
    fillRule: "nonzero",
    d: "M551997 147488l-8043 -30549 4196 0 4579 20032c498,2098 939,4181 1316,6243 804,-3257 1273,-5134 1408,-5632l5774 -20643 4871 0 4381 15467c1074,3840 1870,7445 2382,10808 405,-1927 924,-4138 1557,-6634l4772 -19641 4060 0 -8362 30549 -3933 0 -6407 -23275c-541,-1948 -867,-3143 -988,-3584 -349,1394 -662,2589 -932,3577l-6407 23282 -4224 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 9,
    fill: "black",
    fillRule: "nonzero",
    d: "M584352 136416c0,-4089 1138,-7118 3421,-9088 1899,-1635 4224,-2453 6962,-2453 3036,0 5525,995 7459,2986 1927,1984 2894,4737 2894,8242 0,2845 -426,5078 -1279,6706 -854,1628 -2098,2894 -3734,3797 -1628,903 -3413,1352 -5340,1352 -3101,0 -5604,-989 -7517,-2973 -1913,-1984 -2866,-4843 -2866,-8569zm3840 7c0,2830 619,4950 1856,6351 1245,1407 2802,2112 4687,2112 1863,0 3413,-705 4658,-2120 1237,-1415 1855,-3569 1855,-6464 0,-2730 -625,-4800 -1870,-6200 -1244,-1409 -2794,-2112 -4643,-2112 -1885,0 -3442,697 -4687,2097 -1237,1401 -1856,3513 -1856,6336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 10,
    fill: "black",
    fillRule: "nonzero",
    d: "M609448 147488l0 -22144 3370 0 0 3392c861,-1571 1657,-2610 2390,-3107 732,-505 1536,-754 2410,-754 1266,0 2553,398 3861,1187l-1336 3464c-911,-513 -1821,-768 -2731,-768 -818,0 -1550,248 -2197,739 -648,491 -1110,1173 -1387,2048 -419,1330 -626,2788 -626,4373l0 11570 -3754 0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: 11,
    fill: "black",
    fillRule: "nonzero",
    points: "623712,147488 623712,116939 627467,116939 627467,134340 636342,125344 641191,125344 632743,133572 642045,147488 637423,147488 630070,136175 627467,138706 627467,147488 "
  }), /*#__PURE__*/React.createElement("path", {
    id: 12,
    fill: "black",
    fillRule: "nonzero",
    d: "M660135 140320l3883 512c-604,2255 -1735,4011 -3385,5255 -1650,1245 -3755,1871 -6322,1871 -3228,0 -5788,-996 -7680,-2987 -1891,-1984 -2837,-4779 -2837,-8370 0,-3712 953,-6599 2866,-8647 1913,-2055 4395,-3079 7445,-3079 2951,0 5362,1003 7232,3015 1870,2012 2809,4843 2809,8491 0,220 -7,554 -21,995l-16491 0c142,2425 825,4288 2062,5575 1230,1288 2774,1935 4615,1935 1373,0 2546,-363 3513,-1089 974,-725 1742,-1884 2311,-3477zm-12288 -6016l12331 0c-163,-1863 -640,-3257 -1415,-4188 -1188,-1444 -2738,-2169 -4636,-2169 -1721,0 -3165,576 -4338,1728 -1167,1152 -1814,2695 -1942,4629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 13,
    fill: "black",
    fillRule: "nonzero",
    d: "M668719 147488l0 -22144 3370 0 0 3392c861,-1571 1657,-2610 2390,-3107 732,-505 1536,-754 2410,-754 1266,0 2553,398 3861,1187l-1337 3464c-910,-513 -1820,-768 -2730,-768 -818,0 -1550,248 -2197,739 -648,491 -1110,1173 -1387,2048 -419,1330 -626,2788 -626,4373l0 11570 -3754 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M754000 635031l0 -30550 6058 0 7225 21625c669,2013 1152,3521 1458,4523 349,-1109 896,-2745 1636,-4900l7353 -21248 5411 0 0 30550 -3883 0 0 -25558 -8917 25558 -3641 0 -8817 -26027 0 26027 -3883 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "black",
    fillRule: "nonzero",
    d: "M804261 627863l3883 512c-604,2254 -1735,4011 -3385,5255 -1650,1244 -3755,1870 -6322,1870 -3228,0 -5788,-995 -7680,-2986 -1891,-1985 -2837,-4779 -2837,-8370 0,-3712 953,-6600 2866,-8647 1912,-2056 4394,-3079 7445,-3079 2951,0 5362,1002 7232,3014 1870,2013 2809,4843 2809,8491 0,221 -7,555 -21,996l-16491 0c142,2425 825,4288 2062,5575 1230,1287 2774,1934 4615,1934 1373,0 2546,-363 3513,-1088 974,-725 1742,-1884 2311,-3477zm-12288 -6016l12331 0c-163,-1863 -640,-3257 -1415,-4189 -1188,-1443 -2738,-2168 -4637,-2168 -1720,0 -3164,576 -4337,1728 -1167,1152 -1814,2695 -1942,4629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    fill: "black",
    fillRule: "nonzero",
    d: "M812887 635031l0 -22144 3371 0 0 3143c1621,-2411 3968,-3612 7033,-3612 1337,0 2560,241 3676,718 1117,476 1956,1109 2510,1884 555,775 946,1700 1166,2766 136,697 207,1913 207,3648l0 13597 -3755 0 0 -13455c0,-1528 -142,-2673 -434,-3427 -291,-754 -810,-1358 -1550,-1813 -739,-448 -1614,-676 -2610,-676 -1593,0 -2965,505 -4124,1522 -1159,1010 -1735,2937 -1735,5767l0 12082 -3755 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "black",
    fillRule: "nonzero",
    d: "M844766 631681l512 3314c-1052,221 -1998,334 -2823,334 -1358,0 -2411,-213 -3164,-647 -747,-433 -1273,-995 -1579,-1699 -306,-704 -455,-2183 -455,-4437l0 -12758 -2774 0 0 -2901 2774 0 0 -5476 3754 -2254 0 7730 3755 0 0 2901 -3755 0 0 12971c0,1073 65,1763 200,2069 128,306 341,548 639,732 299,179 726,271 1281,271 412,0 960,-50 1635,-150z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "black",
    fillRule: "nonzero",
    d: "M847063 623959c0,-4089 1138,-7118 3420,-9088 1899,-1636 4224,-2453 6962,-2453 3037,0 5526,995 7460,2986 1927,1984 2894,4736 2894,8242 0,2844 -426,5077 -1280,6706 -853,1628 -2098,2894 -3733,3797 -1629,903 -3414,1351 -5341,1351 -3100,0 -5603,-988 -7516,-2972 -1913,-1984 -2866,-4843 -2866,-8569zm3840 7c0,2830 619,4949 1856,6350 1245,1408 2802,2112 4686,2112 1863,0 3414,-704 4658,-2119 1237,-1415 1856,-3570 1856,-6464 0,-2731 -626,-4800 -1870,-6201 -1245,-1408 -2795,-2112 -4644,-2112 -1884,0 -3441,697 -4686,2098 -1237,1401 -1856,3513 -1856,6336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    fill: "black",
    fillRule: "nonzero",
    d: "M872158 635031l0 -22144 3371 0 0 3392c860,-1572 1657,-2610 2389,-3108 733,-505 1536,-753 2411,-753 1266,0 2553,398 3861,1187l-1337 3463c-910,-512 -1820,-768 -2731,-768 -817,0 -1550,249 -2197,740 -647,491 -1109,1173 -1386,2048 -420,1330 -626,2787 -626,4373l0 11570 -3755 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M154869 635040l0 -30549 11535 0c2026,0 3577,100 4650,292 1501,248 2759,725 3776,1422 1017,704 1835,1685 2454,2944 618,1258 924,2645 924,4160 0,2588 -825,4785 -2482,6578 -1650,1799 -4643,2694 -8967,2694l-7836 0 0 12459 -4054 0zm4054 -16042l7893 0c2617,0 4466,-484 5568,-1458 1095,-974 1643,-2340 1643,-4110 0,-1273 -320,-2369 -967,-3279 -647,-910 -1501,-1514 -2553,-1806 -683,-178 -1941,-270 -3769,-270l-7815 0 0 10923z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    fill: "black",
    fillRule: "nonzero",
    d: "M182816 635040l0 -22144 3371 0 0 3392c860,-1571 1657,-2610 2389,-3107 733,-505 1536,-754 2411,-754 1266,0 2553,398 3861,1188l-1337 3463c-910,-512 -1820,-768 -2731,-768 -817,0 -1550,248 -2197,739 -647,491 -1109,1174 -1386,2048 -420,1330 -626,2788 -626,4373l0 11570 -3755 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 2,
    fill: "black",
    fillRule: "nonzero",
    d: "M195659 623968c0,-4089 1138,-7118 3420,-9088 1899,-1635 4224,-2453 6962,-2453 3037,0 5525,996 7460,2987 1927,1983 2894,4736 2894,8241 0,2845 -427,5078 -1280,6706 -853,1628 -2098,2894 -3733,3798 -1629,902 -3414,1351 -5341,1351 -3100,0 -5603,-989 -7516,-2973 -1913,-1984 -2866,-4843 -2866,-8569zm3840 7c0,2830 618,4950 1856,6351 1244,1408 2802,2112 4686,2112 1863,0 3413,-704 4658,-2119 1237,-1416 1856,-3570 1856,-6465 0,-2730 -626,-4800 -1870,-6200 -1245,-1409 -2795,-2112 -4644,-2112 -1884,0 -3442,697 -4686,2097 -1238,1401 -1856,3513 -1856,6336z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 3,
    fill: "black",
    fillRule: "nonzero",
    d: "M220775 608843l0 -4352 3755 0 0 4352 -3755 0zm-4750 34759l690 -3179c753,192 1344,292 1778,292 768,0 1337,-256 1713,-761 377,-505 569,-1778 569,-3804l0 -23254 3755 0 0 23332c0,2723 -356,4622 -1067,5689 -903,1386 -2403,2083 -4501,2083 -1017,0 -1991,-135 -2937,-398z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 4,
    fill: "black",
    fillRule: "nonzero",
    d: "M245380 627872l3882 512c-604,2255 -1735,4011 -3385,5255 -1649,1245 -3754,1871 -6321,1871 -3229,0 -5789,-996 -7680,-2987 -1892,-1984 -2838,-4779 -2838,-8370 0,-3712 953,-6599 2866,-8647 1913,-2055 4395,-3079 7445,-3079 2952,0 5362,1003 7232,3015 1871,2013 2809,4843 2809,8491 0,220 -7,554 -21,995l-16491 0c142,2425 825,4288 2062,5575 1231,1288 2774,1935 4616,1935 1372,0 2546,-363 3513,-1088 974,-726 1742,-1885 2311,-3478zm-12288 -6016l12330 0c-163,-1863 -640,-3257 -1415,-4188 -1187,-1444 -2738,-2169 -4636,-2169 -1721,0 -3165,576 -4338,1728 -1166,1152 -1813,2695 -1941,4629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 5,
    fill: "black",
    fillRule: "nonzero",
    d: "M268469 626934l3670 512c-406,2524 -1429,4494 -3086,5923 -1657,1429 -3698,2141 -6109,2141 -3022,0 -5454,-989 -7289,-2966 -1841,-1977 -2759,-4807 -2759,-8490 0,-2390 398,-4473 1188,-6265 789,-1785 1991,-3129 3612,-4018 1614,-896 3371,-1344 5276,-1344 2397,0 4367,604 5889,1820 1528,1216 2510,2944 2936,5177l-3626 555c-349,-1486 -960,-2603 -1849,-3356 -882,-747 -1948,-1124 -3200,-1124 -1892,0 -3428,675 -4615,2027 -1181,1358 -1771,3491 -1771,6421 0,2972 569,5127 1707,6471 1145,1344 2631,2020 4458,2020 1480,0 2710,-449 3691,-1351 988,-897 1614,-2283 1877,-4153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 6,
    fill: "black",
    fillRule: "nonzero",
    d: "M283488 631691l512 3314c-1052,220 -1998,334 -2823,334 -1358,0 -2411,-213 -3165,-647 -746,-434 -1273,-996 -1578,-1700 -306,-704 -455,-2183 -455,-4437l0 -12757 -2774 0 0 -2902 2774 0 0 -5475 3754 -2254 0 7729 3755 0 0 2902 -3755 0 0 12970c0,1074 64,1764 199,2069 128,306 342,548 640,733 299,178 726,270 1280,270 413,0 960,-49 1636,-149z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleSvg);
export default __webpack_public_path__ + "static/media/triangleSvg.45c39ebd35df04a37d4fc761b68fd774.svg";
export { ForwardRef as ReactComponent };